import React from 'react';
import './StudioPage.css';
import SubTabBar, { SubTab } from '../../components/shared/SubTabBar';
import { useAppState, StudioTab } from '../../context/AppStateContext';
import AiHubPage from '../ai-hub/AiHubPage';
import ResearchPage from '../research/ResearchPage';
import MediaPage from '../media/MediaPage';
import VisualToolsPage from '../visual-tools/VisualToolsPage';
import MeetingsPage from '../meetings/MeetingsPage';
import AssetsPage from '../assets/AssetsPage';

const TABS: SubTab<StudioTab>[] = [
  { id: 'ai', label: 'AI Hub', icon: 'ai' },
  { id: 'research', label: 'Research', icon: 'research' },
  { id: 'media', label: 'Media', icon: 'media' },
  { id: 'visuals', label: 'Visuals', icon: 'visuals' },
  { id: 'video', label: 'Meetings', icon: 'video' },
  { id: 'assets', label: 'Assets', icon: 'assets' },
];

export default function StudioPage() {
  const { appState, setAppState } = useAppState();

  // For media tab, render immersive mode without tabs
  if (appState.studioTab === 'media') {
    return <MediaPage />;
  }

  const renderTab = () => {
    switch (appState.studioTab) {
      case 'ai': return <AiHubPage />;
      case 'research': return <ResearchPage />;
      case 'media': return <MediaPage />;
      case 'visuals': return <VisualToolsPage />;
      case 'video': return <MeetingsPage />;
      case 'assets': return <AssetsPage />;
      default: return <AiHubPage />;
    }
  };

  return (
    <div className="studio-page">
      <SubTabBar
        tabs={TABS}
        active={appState.studioTab}
        onChange={tab => setAppState(s => ({ ...s, studioTab: tab }))}
      />
      <div className="studio-page__content">
        {renderTab()}
      </div>
    </div>
  );
}
